import { render, staticRenderFns } from "./ReportVendorBookingTotals.vue?vue&type=template&id=56f140d3"
import script from "./ReportVendorBookingTotals.vue?vue&type=script&lang=js"
export * from "./ReportVendorBookingTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports